import ruCommon from './ru/common.json';
import ruSettings from './ru/settings.json';
import enCommon from './en/common.json';
import enSettings from './en/settings.json';
import ruAuth from './ru/auth.json';
import enAuth from './en/auth.json';
import ruChats from './ru/chats.json';
import enChats from './en/chats.json';
import ruAccount from './ru/account.json';
import enAccount from './en/account.json';
import ruDialogs from './ru/dialogs.json';
import enDialogs from './en/dialogs.json';
import ruPeople from './ru/people.json';
import enPeople from './en/people.json';
import ruStories from './ru/stories.json';
import enStories from './en/stories.json';
import ruSessions from './ru/sessions.json';
import enSessions from './en/sessions.json';
import ruSecurity from './ru/security.json';
import enSecurity from './en/security.json';
import ruChatInfo from './ru/chatInfo.json';
import enChatInfo from './en/chatInfo.json';
import ruMessageInfo from './ru/messageInfo.json';
import enMessageInfo from './en/messageInfo.json';
import ruInvites from './ru/invites.json';
import enInvites from './en/invites.json';
import ruChatView from './ru/chatView.json';
import enChatView from './en/chatView.json';
import ruQr from './ru/qr.json';
import ruAdmin from './ru/admin.json';
import enAdmin from './en/admin.json';
import ruMisc2 from './ru/misc2.json';
import enMisc2 from './en/misc2.json';
import ruMisc from './ru/misc.json';
import enMisc from './en/misc.json';
import ruAttach from './ru/attach.json';
import enAttach from './en/attach.json';
import ruCalls from './ru/calls.json';
import enCalls from './en/calls.json';
import ruImageEditor from './ru/imageEditor.json';
import enImageEditor from './en/imageEditor.json';
import ruDeviceCheck from './ru/deviceCheck.json';
import enDeviceCheck from './en/deviceCheck.json';
import ruRooms from './ru/rooms.json';
import enRooms from './en/rooms.json';
import ruApp from './ru/app.json';
import enApp from './en/app.json';
import enQr from './en/qr.json';

/**
 * Реестр языков. Чтобы добавить язык: создать папку locales/<код>/ с теми же файлами,
 * импортировать их здесь и добавить запись в LANGUAGES и resources — остальной код не меняется.
 * Отсутствующие ключи берутся из русского (FALLBACK_LANGUAGE).
 */
export const FALLBACK_LANGUAGE = 'ru';

/** nativeName показывается в переключателе на родном языке и не переводится. */
export const LANGUAGES = [
  { code: 'ru', nativeName: 'Русский' }, // i18n-ok: родное название
  { code: 'en', nativeName: 'English' }, // i18n-ok: родное название
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]['code'];

export const NAMESPACES = ['common', 'settings', 'auth', 'chats', 'account', 'dialogs', 'people', 'stories', 'sessions', 'security', 'chatInfo', 'messageInfo', 'invites', 'chatView', 'qr', 'app', 'rooms', 'deviceCheck', 'imageEditor', 'calls', 'attach', 'misc', 'misc2', 'admin'] as const;

export const resources = {
  ru: { common: ruCommon, settings: ruSettings, auth: ruAuth, chats: ruChats, account: ruAccount, dialogs: ruDialogs, people: ruPeople, stories: ruStories, sessions: ruSessions, security: ruSecurity, chatInfo: ruChatInfo, messageInfo: ruMessageInfo, invites: ruInvites, chatView: ruChatView, qr: ruQr, app: ruApp, rooms: ruRooms, deviceCheck: ruDeviceCheck, imageEditor: ruImageEditor, calls: ruCalls, attach: ruAttach, misc: ruMisc, misc2: ruMisc2, admin: ruAdmin },
  en: { common: enCommon, settings: enSettings, auth: enAuth, chats: enChats, account: enAccount, dialogs: enDialogs, people: enPeople, stories: enStories, sessions: enSessions, security: enSecurity, chatInfo: enChatInfo, messageInfo: enMessageInfo, invites: enInvites, chatView: enChatView, qr: enQr, app: enApp, rooms: enRooms, deviceCheck: enDeviceCheck, imageEditor: enImageEditor, calls: enCalls, attach: enAttach, misc: enMisc, misc2: enMisc2, admin: enAdmin },
};
